<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  persistent: {
    type: Boolean,
    default: false,
  },
})

const model = defineModel<boolean>()
const emit = defineEmits(['close'])
</script>

<template>
  <v-layout>
    <v-navigation-drawer
      v-model="model"
      :persistent="props.persistent"
      location="right"
      temporary
      width="500"
    >
      <div class="slider-header">
        <div class="title">{{ props.title }}</div>
        <div class="close-btn">
          <button @click="emit('close', true)" aria-label="Cerrar">✕</button>
        </div>
      </div>
      <div class="slider-content">
        <slot></slot>
      </div> </v-navigation-drawer
  ></v-layout>
</template>

<style>
.slider-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
}

.slider-header .title {
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  font: normal normal 600 20px/27px Segoe UI;
  color: #001f4a;
}

.slider-header .close-btn {
  padding-right: 16px;
}

.slider-header .close-btn button {
  background: #e7eff9;
  color: #001f4a;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slider-content {
  padding: 0 20px;
}
</style>
